import React from "react";
import { useSelector } from "react-redux";
import VpnKeyIcon from "@material-ui/icons/VpnKey";
import { ButtonGreen } from "../../components/common/ButtonsGenerics";
import TableGeneric from "../../components/common/TableGeneric";

const TokenFamily = ({ handleGenerarToken }) => {

    const { family } = useSelector(state => state.auth);

    const columns = [
        {
            id: "nombre",
            label: "Integrante"
        },
        {
            id: "parentesco",
            label: "Parentesco"
        },
        {
            id: "acciones",
            label: "Acción"
        }
    ];

    const rows = family.map((row, index) => ({

        id: index,

        nombre: `${row.nombre} ${row.apellido}`,

        parentesco: row.parentesco,

        acciones: (
            <ButtonGreen
                onClick={() => {
                    handleGenerarToken(row);
                }}
            >
                <VpnKeyIcon />
            </ButtonGreen>
        )

    }));

    return (
        <TableGeneric
            columns={columns}
            rows={rows}
            pageSize={10}
        />
    );
};

export default TokenFamily;